import { useState } from "react";
import Highcharts from 'highcharts';
import {
  HighchartsProvider, HighchartsChart, Chart, XAxis, YAxis, Tooltip, LineSeries
} from 'react-jsx-highcharts';
import './../sass/chart.scss';
import moment from 'moment';
import { getChart } from "./../helpers/chart";
import { useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

const ChartView = (props) => {
  const [chart, setChart] = useState([]);
  const [loading, setLoading] = useState(true);
  const [interval, setInterval] = useState({
    name: "7D",
    start: moment().subtract(1, "week").unix(),
    end: moment().unix()
  });
  useEffect(() => {
    handleGetChart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[interval]);

  const handleGetChart = async () => {
    setChart([]);
    setLoading(true);
    const [error,response] = await getChart(interval.start, interval.end, props.id);
    setLoading(false);
    if(error) return;
    const chartPoints = response.data.map(item => [item.timestamp, item.price]);
    setChart(chartPoints);
  }

  const handleIntervalChange = (e, newInterval) => {
    if(newInterval === interval.name || !newInterval) return;
    let newStartDate;
    if(newInterval === "1D") {
      newStartDate = moment().subtract(1, "day").unix();
    } else if(newInterval === "7D") {
      newStartDate = moment().subtract(1, "week").unix();
    } else if(newInterval === "1M") {
      newStartDate = moment().subtract(1, "months").unix();
    } else if(newInterval === "6M") {
      newStartDate = moment().subtract(6, "months").unix();
    } else {
      newStartDate = moment().subtract(12, "months").unix();
    }
    setInterval({
      name: newInterval,
      start: newStartDate,
      end: moment().unix()
    });
  };

  return (
    <>
      <ToggleButtonGroup
        color="primary"
        value={interval.name}
        exclusive
        onChange={handleIntervalChange}
        size="small"
        className="mb-3"
      >
        <ToggleButton value="1D">1D</ToggleButton>
        <ToggleButton value="7D">7D</ToggleButton>
        <ToggleButton value="1M">1M</ToggleButton>
        <ToggleButton value="6M">6M</ToggleButton>
        <ToggleButton value="1Y">1Y</ToggleButton>
      </ToggleButtonGroup>

      <HighchartsProvider Highcharts={Highcharts}>
        <HighchartsChart styledMode className="fancyChart" lang={ { noData: 'no data!' }}>
          {
            (chart.length === 0 && !loading) && (
              <div className="no-data">
                No data. Please adjust the range.
              </div>
            )
          }
          {
            (chart.length === 0 && loading) && (
              <div className="no-data">
                Fetching data...
              </div>
            )
          }
          <Chart/>
          <Tooltip 
            valuePrefix="$" 
            valueSuffix=" USD" 
          />
          <XAxis 
            type="category"
            labels={{
              formatter: function() {
                const date = new Date(this.value);
                const dateFormatted = moment(date).format("MMM D YYYY, h:mm A")
                return `${dateFormatted}`;
              }
            }}
            />
          <YAxis>
            <LineSeries 
              name="Performance" 
              data={chart}
            />
          </YAxis>
        </HighchartsChart>
      </HighchartsProvider>
    </>
  );
};

export default ChartView;
